const autoNgTemplateLoaderTemplate1 = require('./registry-form-gitlab.html');

import controller from './registry-form-gitlab.controller';

angular.module('portainer.app').component('registryFormGitlab', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
  bindings: {
    model: '=',
    retrieveRegistries: '<',
    createRegistries: '<',
    actionInProgress: '<',
    projects: '=',
    state: '=',
    resetDefaults: '<',
  },
});
